import { useEffect, useState } from "react";
import { Phone, Menu, X, Star, Facebook } from "lucide-react";
import { BUSINESS } from "@/data/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Recent Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-200 ${
        scrolled
          ? "bg-black/85 backdrop-blur-md border-zinc-800"
          : "bg-gradient-to-b from-black/70 to-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
            <span className="flex h-9 w-9 items-center justify-center bg-red-600 group-hover:bg-red-500 transition-colors duration-150">
              <Star className="h-5 w-5 text-white" fill="white" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl md:text-2xl tracking-wide text-white">
                PRECISION
              </span>
              <span className="block text-[10px] md:text-xs font-bold tracking-[0.3em] text-red-500 uppercase">
                Handyman Services
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
                className="text-sm font-bold uppercase tracking-widest text-zinc-300 hover:text-red-500 transition-colors duration-150"
              >
                {l.label}
              </a>
            ))}
            <a
              href={BUSINESS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-facebook"
              aria-label="Facebook"
              className="flex h-10 w-10 items-center justify-center border border-zinc-700 text-zinc-300 hover:border-red-600 hover:text-red-500 transition-colors duration-150"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href={BUSINESS.phoneHref}
              data-testid="header-call-btn"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 px-5 py-2.5 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-150"
            >
              <Phone className="h-4 w-4" />
              {BUSINESS.phone}
            </a>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black border-t border-zinc-800">
          <div className="px-5 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-bold uppercase tracking-widest text-zinc-200 hover:text-red-500 border-b border-zinc-900"
              >
                {l.label}
              </a>
            ))}
            <a
              href={BUSINESS.phoneHref}
              className="mt-3 inline-flex items-center justify-center gap-2 bg-red-600 px-5 py-3 text-sm font-bold uppercase tracking-wider text-white"
            >
              <Phone className="h-4 w-4" /> {BUSINESS.phone}
            </a>
            <a
              href={BUSINESS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-2 border border-zinc-700 px-5 py-3 text-sm font-bold uppercase tracking-wider text-zinc-100"
            >
              <Facebook className="h-4 w-4" /> Facebook
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
